var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 21,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.574.975v3.143H8.705c-.682 0-1.143.143-1.38.429-.239.286-.358.714-.358 1.286v2.25h3.488l-.464 3.523H6.967v9.036H3.324v-9.036H.29V8.083h3.035V5.487c0-1.476.413-2.62 1.238-3.434.826-.814 1.925-1.22 3.298-1.22 1.167 0 2.071.047 2.714.142Z"
  })));
};
export default SvgFacebook;